import axios from "axios";
import { apiV1, apiV2 } from "../../Auth/Interceptor";

const ACCESS_TOKEN = localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");

const headers = {
    Authorization: `Bearer ${ACCESS_TOKEN}`,
};

// For adjust price
const adjustPrice = async (callData) => {
    const { productId, prevPrice, newPrice, fromDate, toDate } = callData;

    try {
        const response = await apiV1.post(`sellerDropTrack/${productId}/price`, 
            {
                prevPrice: prevPrice,
                currPrice: Number(newPrice),
                startDate: fromDate,
                endDate: toDate
            }
        );
        return response.data;
    }
    catch(err) {
        throw err;
    }
}

const adjustPriceNoDates = async (callData) => {
    const { productId, prevPrice, newPrice } = callData;

    try {
        const response = await apiV1.post(`sellerDropTrack/${productId}/price`, 
            {
                prevPrice: prevPrice,
                currPrice: Number(newPrice)
            }
        );
        return response.data;
    }
    catch(err) {
        throw err;
    }
}

const createNewCoupon = async (callData) => {
    const {
        productId,
        couponName,
        couponType,
        discountPercentage,
        discountAmount,
        startDate,
        endDate,
        isOnlyForDropTrackUsers,
    } = callData;

    try {
        const response = await apiV1.post(`sellerDropTrack/${productId}/coupon/`,
            {
                couponName,
                typeCoupon: couponType,
                discountPercent: discountPercentage,
                discountMoney: discountAmount,
                startDate,
                endDate,
                isOnlyForDropTrackUsers
            },
        );
        return response.data;
    }
    catch(err) {
        throw err;
    }
}

const getInactiveCoupons = async () => {
    try {
        const response = await apiV1.get(`coupon/seller`);
        const data = response.data.data.filter(coupon => {
            const currentDate = new Date();
            const endDateObj = new Date(coupon.endDate);
            return currentDate > endDateObj;
        });
        return data;
    }
    catch(err) {
        throw err;
    }
}

const createBundle = async (callData) => {
    try {
        const response = await apiV1.post(`sellerDropTrack/createBundle`, 
            callData,
        );
        return response.data;
    }
    catch(err) {
        throw err;
    }
}

const reactivateCoupon = async (callData) => {
    const {
        productId,
        startDate,
        endDate,
        isOnlyForDropTrackUsers,
        isOnlyForProduct,
    } = callData;

    try {
        const response = await apiV1.put(`sellerDropTrack/${productId}/update`,
            {
                startDate,
                endDate,
                productId,
                isOnlyForDropTrackUsers,
                isOnlyForProduct,
            },    
        );
        return response.data;
    }
    catch(err) {
        throw err;
    }
}

const markAllNotificationsAsRead = async () => {
    try {
        const response = await apiV1.put(`notification/readAll`, 
            {}
        );
        return response;
    }
    catch(err) {
        return err;
    }
}

const getInventoryProducts = async () => {
    try {
        const response = await apiV1.get(`inventory/getAll/product`);
        return response.data.data.products;
    }
    catch(err) {
        throw err;
    }
}

const deleteProduct = async (productId) => {
    try {
        const response = await apiV1.delete(`inventory/${productId}`);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to delete product with ID: ${productId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const getAudios = async () => {
    try {
        const response = await apiV1.get(`songs`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const getTags = async () => {
    try {
        const response = await apiV1.get(`inventory/getAllTags`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const createPost = async (callData) => {
    try {
        const response = await apiV1.post(`sellerpost`, 
            callData
        );

        if (!response || response?.status !== 200) {
            throw new Error('Failed to create post.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const deletePost = async (postId) => {
    try {
        const response = await apiV1.delete(`sellerpost/${postId}`);

        if (!response || response?.status !== 200) {
            throw new Error('Failed to delete post.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const fetchPreSignedURL = async (extension, type) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}v1/upload`, 
            {
                contentType: type,
                ext: extension,
                isPublic: true,
            },
            {
                headers: headers
            }
        );
        return response.data.data;
    }
    catch (error) {
        console.log(error);
        throw error;
    }
}

async function fetchPreSignedURLForVideo(extension, type) {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}v1/video/presigned`, 
            {
                contentType: type,
                ext: extension,
                isPublic: true,
            },
            {
                headers: headers
            }
        );
        return response.data.data;
    }
    catch (error) {
        console.log(error);
        throw error;
    }
}

const uploadFileToPresignedURL = async (file, fileUrl) => {
    try {
        await fetch(fileUrl, {
            method: "PUT",
            body: file,
        });
    }
    catch (error) {
        throw error;
    }
}

const getSinglePost = async (id) => {
    try {
        const response = await apiV1.get(`sellerpost/${id}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const getProductByID = async (productId) => {
    try {
        const response = await axios.get(`https://productserver.xenie.in/product/${productId}`);
        
        if (!response || response.status !== 200) {
            throw new Error('Failed to fetch product.');
        }
        return response;
    } catch (err) {
        throw err;
    }
}

const getPostProfile = async (id) => {
    try {
        const response = await apiV1.get(`sellerProfile/profile/${id}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const getPostComments = async (postID) => {
    try {
        const response = await apiV1.get(`sellercomment/${postID}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const getChildComments = async (callData) => {
    const { postID, commentID } = callData;

    try {
        const response = await apiV1.get(`sellercomment/comment/${postID}/${commentID}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const postComment = async (callData) => {
    try {
        const response = await apiV1.post(`sellercomment`, callData);

        if (!response || response.status !== 200) {
            throw new Error('Failed to post comment.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const postChildComment = async (callData) => {
    try {
        const response = await apiV1.post(`sellercomment`, callData);

        if (!response || response.status !== 200) {
            throw new Error('Failed to post comment reply.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const followSeller = async (sellerId) => {
    try {
        const response = await apiV1.post(`followSeller`, 
            {
                followTo: sellerId
            }
        );
        return response.data;
    }
    catch(err) {
        throw err;
    }
}

const unfollowSeller = async (sellerId) => {
    try {
        const response = await apiV1.delete(`followseller/${sellerId}`);
        return response.data;
    }
    catch(err) {
        throw err;
    }
}

const checkFollowing = async (userId) => {
    try {
        const response = await apiV1.get(`followseller/${userId}`);
        return response.data.data.checkForFollowed;
    }
    catch(err) {
        throw err;
    }
}

const checkUserLikeOnPost = async (postId) => {
    try {
        const response = await apiV1.get(`sellerpost/checklike/${postId}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const likePost = async (postId) => {
    try {
        const response = await apiV1.get(`sellerpost/likes/${postId}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const unlikePost = async (postId) => {
    try {
        const response = await apiV1.get(`sellerpost/unlike/${postId}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const toggleCommentingOnPost = async (callData) => {
    try {
        await apiV1.put(`sellerpost/comment/post`, callData);
    }
    catch(err) {
        throw err;
    }
}

const checkCommentingOnPost = async (postId) => {
    try {
        const response = await apiV1.get(`sellerpost/comment/check/${postId}`);
        return response.data.data.commentAllow;
    }
    catch(err) {
        throw err;
    }
}

const addMusicToSaved = async (trackId) => {
    try {
        const response = await apiV1.post(`song`, 
            {
                trackId: trackId
            }
        );
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const removeMusicFromSaved = async (trackId) => {
    try {
        const response = await apiV1.delete(`song/${trackId}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const checkSongSavedStatus = async (trackId) => {
    try {
        const response = await apiV1.get(`song/status/${trackId}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const getAllSavedSongs = async () => {
    try {
        const response = await apiV1.get(`song`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const likeComment = async (commentId) => {
    try {
        const response = await apiV1.get(`sellercomment/like/${commentId}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const unlikeComment = async (commentId) => {
    try {
        const response = await apiV1.get(`sellercomment/unlike/${commentId}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const checkLikeOnComment = async (commentId) => {
    try {
        const response = await apiV1.get(`sellercomment/checkLike/${commentId}`);
        return response.data.data;
    }
    catch(err) {
        throw err;
    }
}

const checkEmailOnForgotPassword = async (email) => {
    try {
        const response = await apiV1.put(`forgetPassword/check`,
            {
                email: email,
            }
        );
        
        return response; // Return the response even if status isn't 200
    }
    catch (err) {
        return err.response || err; // Return the error response instead of throwing
    }
}

const changePasswordOfUser = async (callData) => {
    try {
        const response = await axios.put(`${process.env.REACT_APP_API_URL}v1/forgetPassword/change`,
            callData,
            {
                headers: headers,
            }
        );
        return response.data;
    }
    catch(err) {
        return err.response.data;
    }
}

const applySeller = async (callData) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}v1/sellerRequest`,
            callData,
            {
                headers: headers,
            }
        );
        return response.data;
    }
    catch(err) {
        return err.response.data;
    }
}

const getCategoriesForStore = async () => {
    try {
        const response = await apiV1.get(`category/getAll`);
        return response.data.data;
    }
    catch(err) {
        return err;
    }
}

const getCollectionForCategory = async (categoryId) => {
    try {
        const response = await apiV1.get(`collection/getAll/${categoryId}`);
        return response.data.data;
    }
    catch(err) {
        return err;
    }
}

const getCustomCollectionsForStore = async () => {
    try {
        const response = await apiV1.get(`customCollection/getAll`);
        return response.data.data;
    }
    catch(err) {
        return err;
    }
}

const createProduct = async (callData) => {
    try {
        const response = await apiV1.post('inventory/create',
            callData
        );
        return response.data;
    }
    catch(err) {
        return err;
    }
}

const createDraftProduct = async (callData) => {
    try {
        const response = await apiV1.post(`inventory`,
            callData
        );
        return response;
    }
    catch(err) {
        return err;
    }
}

const updateProduct = async (callData, productId) => {
    try {
        const response = await apiV1.put(`inventory/${productId}`,
            callData
        );

        if (!response || response.status !== 200) {
            throw new Error(`Failed to update product with ID: ${productId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const accessProductVisibility = async (productId) => {
    try {
        const response = await apiV1.get(`inventory/checkVisibility/${productId}`);
        return response.data.data;
    }
    catch(err) {
        return err;
    }
}

const trackOrder = async (orderId) => {
    try {
        const response = await apiV1.get(`track/track?id=${orderId}`);
        return response.data.data;
    }
    catch(err) {
        return err;
    }
}

const generateLabel = async (orderId) => {
    try {
        const response = await apiV1.get(`track/generateLabel?id=${orderId}`);
        return response.data.data;
    }
    catch(err) {
        return err;
    }
}

const generatePickup = async (callData) => {
    try {
        const response = await apiV1.post(`track/pickUp`, callData);
        return response.data;
    }
    catch(err) {
        return err;
    }
}

const updateOrder = async (callData) => {
    try {
        const response = await apiV1.put(`ordermanage`, callData);
        return response.data;
    }
    catch(err) {
        return err;
    }
}

const getOrderStatusById = async (orderId) => {
    try {
        const response = await apiV1.get(`ordermanage/getStatus?id=${orderId}`);
        return response.data.data;
    }
    catch(err) {
        return err;
    }
}

const updateReturnOrderStatus = async (orderId, payload) => {
    try {
        const response = await apiV2.put(`seller/orderReturn/${orderId}`, payload);
        return response;
    }
    catch(err) {
        return err;
    }
}

const getDelhiveryDetails = async (orderId) => {
    try {
        const response = await apiV1.get(`id=${orderId}`);
        return response.data.data;
    }
    catch(err) {
        return err;
    }
}

async function generateExcelSheet(callData) {
    try {
        const response = await apiV1.post('bulk/create', callData, {
            responseType: 'blob',
        });

        if (!response || response.status !== 200) {
            throw new Error('Error generating Excel sheet.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const postExcel = async (file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await apiV1.post('bulk/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response;
    }
    catch (err) {
        return err;
    }
};

const reportPost = async (callData) => {
    try {
        const response = await apiV1.post('reportBySeller/post', callData);
        return response.data;
    }
    catch(err) {
        return err;
    }
}

const deleteComment = async (commentId) => {
    try {
        const response = await apiV1.delete(`sellercomment/${commentId}`);

        if (!response || response.status !== 200) {
            throw new Error('Failed to delete comment.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const reportComment = async (callData) => {
    try {
        const response = await apiV1.post('reportBySeller/comment', callData);
        return response.data;
    }
    catch(err) {
        return err;
    }
}

async function updateInventoryVariant(callBody, variantId) {
    try {
        const response = await apiV1.put(`inventory/varient/${variantId}`, callBody);

        if (!response || response.status !== 200) {
            throw new Error('Failed to update variant stock.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const createCategory = async (callData) => {
    try {
        const response = await apiV1.post('category', callData);
        return response;
    }
    catch(err) {
        return err;
    }
}

const updateCategory = async (callData, categoryId) => {
    try {
        const response = await apiV1.put(`category/${categoryId}`, callData);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to update category with ID: ${categoryId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const getCategory = async (categoryId) => {
    try {
        const response = await apiV1.get(`category/${categoryId}`);
        return response;
    }
    catch(err) {
        return err;
    }
}

const getCategoryCollections = async (categoryId) => {
    try {
        const response = await apiV1.get(`collection/getAll/${categoryId}`);
        return response;
    }
    catch(err) {
        return err;
    }
}

const getCollection = async (collectionId) => {
    try {
        const response = await apiV1.get(`collection/${collectionId}`);
        return response;
    }
    catch(err) {
        return err;
    }
}

const deleteProductFromCollection = async (collectionId, productId) => {
    try {
        const response = await apiV1.delete(`collection/${collectionId}/${productId}`);
        return response;
    }
    catch(err) {
        return err;
    }
}

const createCollection = async (callData) => {
    try {
        const response = await apiV1.post('collection', callData);
        return response;
    }
    catch(err) {
        return err;
    }
}

const updateCollection = async (callData, collectionId) => {
    try {
        const response = await apiV1.put(`collection/${collectionId}`, callData);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to update collection with ID: ${collectionId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const getCustomCollection = async (customCollectionId) => {
    try {
        const response = await apiV1.get(`customCollection/${customCollectionId}`);
        return response;
    }
    catch(err) {
        return err;
    }
}

const deleteProductFromCustomCollection = async (customCollectionId, productId) => {
    try {
        const response = await apiV1.delete(`customCollection/${customCollectionId}/${productId}`);
        return response;
    }
    catch(err) {
        return err;
    }
}

const createCustomCollection = async (callData) => {
    try {
        const response = await apiV1.post('customCollection', callData);
        return response;
    }
    catch(err) {
        return err;
    }
}

const deleteCustomCollection = async (customCollectionId) => {
    try {
        const response = await apiV1.delete(`customCollection/${customCollectionId}`);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to delete custom collection with ID: ${customCollectionId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const updateCustomCollection = async (callData, customCollectionId) => {
    try {
        const response = await apiV1.put(`customCollection/${customCollectionId}`, callData);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to update custom collection with ID: ${customCollectionId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const deleteCategory = async (categoryId) => {
    try {
        const response = await apiV1.delete(`category/${categoryId}`);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to delete category with ID: ${categoryId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const deleteCollection = async (collectionId) => {
    try {
        const response = await apiV1.delete(`collection/${collectionId}`);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to delete collection with ID: ${collectionId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const updateCategoryCollection = async (callData, collectionId) => {
    try {
        const response = await apiV1.put(`collection/${collectionId}`, callData);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to update category collection with ID: ${collectionId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const createCoupon = async (callData) => {
    try {
        const response = await apiV1.post('coupon/seller', callData);

        if (!response || response.status !== 200) {
            throw new Error('Failed to create coupon.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const updateCoupon = async (callData, couponId) => {
    try {
        const response = await apiV1.put(`coupon/seller/${couponId}`, callData);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to update coupon with ID: ${couponId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const deleteCoupon = async (couponId, callData) => {
    try {
        const response = await apiV1.delete(`coupon/seller/${couponId}`, { data: callData });

        if (!response || response.status !== 200) {
            throw new Error(`Failed to delete coupon with ID: ${couponId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

const deleteMedia = async (mediaId, callData) => {
    try {
        const response = await apiV1.delete(`media/delete?id=${mediaId}`, { data: callData });

        if (!response || response.status !== 200) {
            throw new Error(`Failed to delete media with ID: ${mediaId}`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function addStorefront(callData) {
    try {
        const response = await apiV1.post('storefront', callData);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to add storefront`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function updateStorefront(callData) {
    try {
        const response = await apiV1.put('storefront', callData);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to update storefront`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function addStorefrontAbout(callData) {
    try {
        const response = await apiV1.post('storefrontabout', callData);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to add storefront about`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function updateStorefrontAbout(callData) {
    try {
        const response = await apiV1.put('storefrontabout', callData);

        if (!response || response.status !== 200) {
            throw new Error(`Failed to update storefront about`);
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function getStorefrontSEOData() {
    try {
        const response = await apiV1.get('storefrontseo');

        if (!response || response.status !== 200) {
            throw new Error('Failed to fetch store SEO data.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function addStorefrontSEO(callBody) {
    try {
        const response = await apiV1.post('storefrontseo', callBody);

        if (!response || response.status !== 200) {
            throw new Error('Failed to add store SEO data.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function updateStorefrontSEO(callBody) {
    try {
        const response = await apiV1.put('storefrontseo', callBody);

        if (!response || response.status !== 200) {
            throw new Error('Failed to update store SEO data.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function getProduct(productId) {
    try {
        const response = await apiV1.get(`inventory/${productId}`);

        if (!response || response.status !== 200) {
            throw new Error('Failed to find product.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function getSellerProfile() {
    try {
        const response = await apiV1.get('sellerMembers/profile');

        if (!response || response.status !== 200) {
            throw new Error('Failed to get seller profile.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function getBusinessInfo() {
    try {
        const response = await apiV1.get('settings/store');

        if (!response || response.status !== 200) {
            throw new Error('Failed to get business info.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function inviteSellerMember(callBody) {
    try {
        const response = await apiV1.post('sellerMembers/invite', callBody);

        if (!response || response.status !== 200) {
            throw new Error('Failed to send seller member invite.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function removeSellerMember(sellerId) {
    try {
        const response = await apiV1.delete(`sellerMembers/${sellerId}`, { id: sellerId });

        if (!response || response.status !== 200) {
            throw new Error('Failed to remove seller member.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function updateSellerProfile(callData) {
    try {
        const response = await apiV1.put('sellerMembers/update', callData);

        if (!response || response.status !== 200) {
            throw new Error('Failed to update seller profile.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function updatePaymentInfo(callData) {
    try {
        const response = await apiV1.put('settings/paymentInfo', callData);

        if (!response || response.status !== 200) {
            throw new Error('Failed to update payment info.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function updatePassword(callData) {
    try {
        const response = await apiV1.put('sellerMembers/changePassword', callData);

        if (!response || response.status !== 200) {
            throw new Error('Failed to update password.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function updateStoreInfo(callData) {
    try {
        const response = await apiV1.put('settings/storeInfo', callData);

        if (!response || response.status !== 200) {
            throw new Error('Failed to update store info.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function getGSTInfo(callData) {
    try {
        const response = await apiV1.post('gstins', callData);
        if (response?.data?.statusCode !== "10000") {
            throw new Error('Please enter a valid GST Number.');
        }
        return response;
    } catch (err) {
        if (err.response?.status === 500) {
            throw new Error('Invalid GST number or server error.');
        }
        throw err.message ? new Error(err.message) : new Error('Please enter a valid GST Number.');
    }
}

async function fetchPincodeDetails(pincode) {
    try {
        const response = await axios.get(`https://api.postalpincode.in/pincode/${pincode}`);

        if (!response || response.status !== 200) {
            throw new Error('Failed to find area details.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function signInSeller(callBody) {
    try {
        const response = await apiV1.post('sellerlogin', callBody);

        if (!response || response.status !== 200) {
            throw new Error('Failed to login seller.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function registerSeller(callBody) {
    try {
        const response = await apiV1.post('register', callBody);

        if (!response || response.status !== 200) {
            throw new Error('Failed to register seller.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function addSizeChart(callBody) {
    try {
        const response = await apiV1.post('size-chart', callBody);

        if (!response || response.status !== 200) {
            throw new Error('Failed to add size chart.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function deleteSizeChart(chartId) {
    try {
        const response = await apiV1.delete(`size-chart/${chartId}`);

        if (!response || response.status !== 200) {
            throw new Error('Failed to delete size chart.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function updateSizeChart(callBody, chartId) {
    try {
        const response = await apiV1.put(`size-chart/${chartId}`, callBody);

        if (!response || response.status !== 200) {
            throw new Error('Failed to update size chart.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function getSizeChartById(chartId) {
    try {
        const response = await apiV1.get(`size-chart/${chartId}`);

        if (!response || response.status !== 200) {
            throw new Error('Failed to fetch size chart.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function addSizeChartToProduct(callBody, productId) {
    try {
        const response = await apiV1.post(`inventory/${productId}/assign-size-chart`, callBody);

        if (!response || response.status !== 200) {
            throw new Error('Failed to add size chart to product.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function updateProductVariant(callBody, variantId) {
    try {
        const response = await apiV1.put(`inventory/varient/${variantId}`, callBody);

        if (!response || response.status !== 200) {
            throw new Error('Failed to update to product variant.');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

async function getOrderInvoice(orderId) {
    try {
        const response = await apiV2.get(`invoice/seller/?orderId=${orderId}`, {
            responseType: 'blob'
        });
        
        if (!response || response.status !== 200) {
            throw new Error('Failed to fetch order invoice.');
        }
        return response;
    } catch (err) {
        throw err;
    }
}

async function cachedDataPublish(pathArray) {
    try {
        const response = await axios.post('https://invalidate.xenie.in/invalidate', { paths: pathArray });

        if (!response || response.status !== 200) {
            throw new Error('Storefront publish error');
        }
        return response;
    }
    catch (err) {
        throw err;
    }
}

export {
    adjustPrice,
    adjustPriceNoDates,
    createNewCoupon,
    getInactiveCoupons,
    createBundle,
    reactivateCoupon,
    markAllNotificationsAsRead,
    getInventoryProducts,
    getAudios,
    getTags,
    createPost,
    deletePost,
    getSinglePost,
    getProductByID,
    postComment,
    getPostComments,
    postChildComment,
    getChildComments,
    getPostProfile,
    followSeller,
    unfollowSeller,
    checkFollowing,
    checkUserLikeOnPost,
    deleteProduct,

    fetchPreSignedURL,
    uploadFileToPresignedURL,

    likePost,
    unlikePost,
    toggleCommentingOnPost,
    checkCommentingOnPost,
    addMusicToSaved,
    removeMusicFromSaved,
    checkSongSavedStatus,
    getAllSavedSongs,
    likeComment,
    unlikeComment,
    checkLikeOnComment,

    checkEmailOnForgotPassword,
    changePasswordOfUser,
    applySeller,

    getCategoriesForStore,
    getCollectionForCategory,
    getCustomCollectionsForStore,
    createProduct,
    createDraftProduct,
    updateProduct,
    accessProductVisibility,

    trackOrder,
    generateLabel,
    generatePickup,
    updateOrder,
    getOrderStatusById,
    getDelhiveryDetails,
    getOrderInvoice,
    updateReturnOrderStatus,

    generateExcelSheet,
    postExcel,

    reportPost,
    reportComment,
    deleteComment,

    updateInventoryVariant,

    createCategory,
    updateCategory,
    getCategory,
    getCategoryCollections,
    getCollection,
    deleteProductFromCollection,
    createCollection,
    updateCollection,
    getCustomCollection,
    deleteProductFromCustomCollection,
    createCustomCollection,
    deleteCustomCollection,
    updateCustomCollection,
    deleteCategory,
    deleteCollection,
    updateCategoryCollection,

    createCoupon,
    updateCoupon,
    deleteCoupon,

    deleteMedia,

    updateStorefront,
    addStorefrontAbout,
    updateStorefrontAbout,
    getStorefrontSEOData,
    addStorefrontSEO,
    updateStorefrontSEO,
    getProduct,
    addSizeChart,
    deleteSizeChart,
    updateSizeChart,
    addSizeChartToProduct,
    getSizeChartById,
    updateProductVariant,

    getSellerProfile,
    updateSellerProfile,
    getBusinessInfo,
    updatePaymentInfo,
    updateStoreInfo,
    updatePassword,
    inviteSellerMember,
    removeSellerMember,
    addStorefront,

    // Registration
    getGSTInfo,
    fetchPincodeDetails,
    registerSeller,
    signInSeller,

    
    fetchPreSignedURLForVideo,
    cachedDataPublish,
}
